<template>
  <v-dialog v-model="dialog" max-width="600">
    <ValidationObserver ref="transferForm" v-slot="{ invalid, passes }">
      <form
        rel="addCommentForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7">Převést objednávku pod jiného zákazníka</v-card-title>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <CustomerAutocomplete v-model="customerId" :items="customers" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pl-7 pr-7 pb-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Převést
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import CustomerAutocomplete from '@/components/forms/inputs/CustomerAutocomplete'
export default {
  name: 'OrderTransferDialog',
  components: { CustomerAutocomplete },
  data() {
    return {
      customerId: null,
      customers: [],
      saving: false,
      dialog: false,
    }
  },
  created() {
    const model = this
    this.$eventBus.$on('orderTransferDialog', function (dialog) {
      model.customerId = null
      model.customers = null
      model.dialog = dialog
    })
  },
  methods: {
    ...mapActions({
      transferOrder: 'order/transferOrder',
    }),
    submit() {
      this.$confirm('', {
        title: 'Opravdu převést objednávku?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.transferOrder({
            id: this.$route.params.orderId,
            customerId: this.customerId,
          }).finally(() => {
            this.saving = false
            this.$refs.transferForm.reset()
            this.$emit('orderTransferred')
            this.close()
          })
        }
      })
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
